import { apiSlice } from "../apiSlice";

export interface CreateOrderData {
    address: string,
    cartId?: string,
    displayName: string,
    imageUrl: string,
    orderCreatedBy: string,
    paymentMethod: string,
    restaurantId: string,
    customerId: string,
    deliveryTime?: any,
    isScheduledOrder: boolean,
    totalPrice: number,
    orderItems: any
    isDirectRestaurantOrder: boolean;
    deliveryContactName?: string,
    deliveryContactPhoneNumber?: string
    orderSource: "CustomerWeb"
    deliveryInstructions?: string;
    orderNote?: string;
    deliveryTimeSlot?: string | null;
}

interface CreateOrderResponse {
    orderId: string;
    customer: {
        id: string;
        displayName: string;
    };
    restaurantId: string;
    totalPrice: number;
    orderStatus: string;
    orderReference: string;
}

interface updateOrderStatus {
    orderId: string;
    orderStatus: string;
}

export interface updateOrderPaymentMethodRequest {
    orderId: string;
    paymentMethod: string;
    totalPrice: number;
    walletPaymentAmount?: number;
}

export interface SignedFieldsResponse {
    accessKey: string;
    profileId: string;
    transactionUuid: string;
    signedFieldNames: string;
    unsignedFieldNames: string;
    signedDateTime: string;
    locale: string;
    transactionType: string;
    referenceNumber: string;
    amount: number;
    currency: string;
    billToForename: string;
    billToSurname: string;
    billToEmail: string;
    billToAddressLine1: string;
    billToAddressCity: string;
    billToAddressPostalCode: string;
    billToAddressState: string;
    billToAddressCountry: string;
    paymentUrl: string;
    signature: string;
    customReceiptPage: string;
    customCancelPage: string;
    customFailurePage: string;
    paymentTokenType?: string;
    paymentTokenCreate?: string;
}

interface SignedFieldsResponseExistingCard {
    accessKey: string;
    profileId: string;
    transactionUuid: string;
    signedFieldNames: string;
    unsignedFieldNames: string;
    signedDateTime: string;
    locale: string;
    transactionType: string;
    referenceNumber: string;
    amount: number;
    currency: string;
    billToForename: string;
    billToSurname: string;
    billToEmail: string;
    billToAddressLine1: string;
    billToAddressCity: string;
    billToAddressPostalCode: string;
    billToAddressState: string;
    billToAddressCountry: string;
    paymentUrl: string;
    signature: string;
    customReceiptPage: string;
    customCancelPage: string;
    customFailurePage: string;
    paymentToken?: string | undefined;
}

interface CheckDeliveryLocationRequest {
    point: {
        latitude: number;
        longitude: number;
    };
    restaurantId: string;
}

interface CheckDeliveryLocationResponse {
    isInsideDeliveryZone: boolean;
    // isDeliveryFree: boolean;
    deliverySources: {
        expressCarts?: Array<{
            cartId: string;
            distanceInKm: number;
        }>;
        standardCart?: {
            cartId: string;
            distanceInKm: number;
        };
    };
}

export interface CancelOrderRequest {
    orderId: string;
    orderStatus: string;
    specialNote?: string;
}


const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const orderService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createOrder: builder.mutation<CreateOrderResponse, CreateOrderData>({
            query: (data) => ({
                url: `https://customersitehttps-createorder-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: "POST",
                body: data,
                responseHandler: async (response) => response.json(),
            }),
        }),
        createCardPayment: builder.mutation<any, any>({
            query: (data) => ({
                url: `https://userhttps-processpayment-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: "POST",
                body: data,
                responseHandler: async (response) => response.text(),
            }),
        }),
        updateOrderStatus: builder.mutation<any, updateOrderStatus>({
            query: (data) => ({
                url: `https://userhttps-updateorderstatus-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: "POST",
                body: data,
                responseHandler: async (response) => response.text(),
            }),
        }),
        updateOrderPaymentMethod: builder.mutation<updateOrderPaymentMethodRequest, updateOrderPaymentMethodRequest>({
            query: (data) => ({
                url: `https://userhttps-updateorderpaymentmethodandamounts-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: "POST",
                body: data,
                responseHandler: async (response) => response.text(),
            }),
        }),

        createHostedCheckoutSession: builder.mutation<
            { signedFields: Record<string, string> },
            { orderId: string; amount: number }
        >({
            query: ({ orderId, amount }) => ({
                url: `https://userhttps-createhostedcheckoutsession-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ orderId, amount }),
            }),
        }),

        getSignedFields: builder.query<
            SignedFieldsResponse,
            { orderId: string; customerId: string; }
        >({
            query: ({ orderId, customerId }) => ({
                url: `https://userhttps-getcardpaymentdetails-${API_BASE_DOMAIN}-uc.a.run.app?orderId=${orderId}&customerId=${customerId}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            }),
        }),

        getSignedFieldsForExistingCard: builder.query<
            SignedFieldsResponseExistingCard,
            { orderId: string; customerId: string; userId: string;paymentMethodIndex: number }
        >({
            query: ({ orderId, customerId, userId, paymentMethodIndex }) => ({
                url: `https://userhttps-getoneclickpaymentdetails-${API_BASE_DOMAIN}-uc.a.run.app?orderId=${orderId}&customerId=${customerId}&userId=${userId}&paymentMethodIndex=${paymentMethodIndex}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            }),
        }),

        checkDeliveryLocation: builder.query<CheckDeliveryLocationResponse, CheckDeliveryLocationRequest>({
            query: ({ point, restaurantId }) => ({
                url: `https://customersitehttps-checkpointinsidedeliveryzone-${API_BASE_DOMAIN}-uc.a.run.app/`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: { point, restaurantId },
            }),
        }),

        cancelOrder: builder.mutation<string, CancelOrderRequest>({
            query: ({ orderId, specialNote, orderStatus }) => ({
                url: `https://customersitehttps-cancelorder-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: { orderId, specialNote, orderStatus },
                responseHandler: async (response) => response.text(),
            }),
        }),
        // Request refund endpoint
        requestRefund: builder.mutation<string, { orderId: string; description?: string }>({
            query: (payload) => ({
                url: `https://customerhttps-requestrefund-${API_BASE_DOMAIN}-uc.a.run.app/`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: payload,
                responseHandler: async (response) => response.text(),
            }),
        }),
    })
})

export const {
    useCreateOrderMutation,
    // useCreateCardPaymentMutation,
    // useUpdateOrderStatusMutation,
    // useUpdateOrderPaymentMethodMutation,
    // useCreateHostedCheckoutSessionMutation,
    useGetSignedFieldsQuery,
    useLazyGetSignedFieldsQuery,
    useLazyCheckDeliveryLocationQuery,
    useCancelOrderMutation,
    useRequestRefundMutation,
    useGetSignedFieldsForExistingCardQuery,
    useLazyGetSignedFieldsForExistingCardQuery
} = orderService;